import React from 'react';
import styled from 'styled-components';
import { NavLink } from 'react-router-dom';
import { CallHistoryIcon, ContactIcon, EtcIcon, KakaoBubbleIcon, LogoSvg, MenuFoldIcon, MenuUnfoldIcon, MobileIcon, PhoneIcon, RoutingIcon, MusicIcon, SendIcon, SmsIcon, StatsIcon, UserIcon } from './Icons';
import { hasCorePermission, navigation } from './navigation';
import { useAuth } from '../../contexts/AuthContext';

interface SidebarProps { isCollapsed: boolean; setIsCollapsed: (value: boolean) => void; width: number; }
const Shell = styled.aside<{ $width: number }>`
  width: ${({ $width }) => $width}px; flex-shrink: 0; height: 100dvh; display: flex; flex-direction: column;
  background: ${({ theme }) => theme.name === 'dark' ? '#191B20' : '#F7F8FA'};
  border-right: 1px solid ${({ theme }) => theme.color.primary_300}; color: ${({ theme }) => theme.color.text_color_100};
`;
const Brand = styled.div<{ $collapsed: boolean }>`
  height: 64px; display: flex; align-items: center; gap: 9px; padding: 0 ${({ $collapsed }) => $collapsed ? 17 : 18}px; flex-shrink: 0;
  strong { display: block; font-size: 14px; font-weight: 600; white-space: nowrap; color: ${({ theme }) => theme.color.text_color_100}; }
  small { color: ${({ theme }) => theme.color.text_color_300}; font-size: 10px; }
`;
const Nav = styled.nav`flex: 1; overflow-y: auto; padding: 6px 10px 16px;`;
const Group = styled.div`margin-bottom: 20px; &:last-child { margin-bottom: 0; }`;
const Label = styled.div`padding: 0 10px 6px; font-size: 11px; font-weight: 500; color: ${({ theme }) => theme.color.text_color_300};`;
const Item = styled(NavLink)<{ $collapsed: boolean }>`
  display: flex; align-items: center; justify-content: ${({ $collapsed }) => $collapsed ? 'center' : 'flex-start'};
  gap: 9px; min-height: 36px; padding: 7px 10px; margin: 2px 0; border-radius: 6px;
  color: ${({ theme }) => theme.color.text_color_200}; text-decoration: none; font-size: 13px; white-space: nowrap;
  svg { width: 17px; height: 17px; flex-shrink: 0; }
  span { overflow: hidden; text-overflow: ellipsis; }
  &:hover { background: ${({ theme }) => theme.color.primary_50}; }
  &.active { color: ${({ theme }) => theme.color.text_color_100}; background: ${({ theme }) => theme.name === 'dark' ? theme.color.primary_50 : '#E9ECF0'}; font-weight: 600; }
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.color.point_y_100}; outline-offset: 1px; }
`;
const Footer = styled.div`padding: 12px; border-top: 1px solid ${({ theme }) => theme.color.primary_300};`;
const Collapse = styled.button`
  width: 100%; display: flex; align-items: center; justify-content: center; gap: 8px; min-height: 30px;
  border: 0; background: transparent; color: ${({ theme }) => theme.color.text_color_300}; font-size: 12px; cursor: pointer;
  &:focus-visible { outline: 2px solid ${({ theme }) => theme.color.point_y_100}; outline-offset: 2px; }
`;
const icons: Record<string, React.ReactNode> = { stats: <StatsIcon />, history: <CallHistoryIcon />, mobile: <MobileIcon />, kakao: <KakaoBubbleIcon />, sms: <SmsIcon />, send: <SendIcon />, contact: <ContactIcon />, phone: <PhoneIcon />, audio: <MusicIcon />, routing: <RoutingIcon />, user: <UserIcon />, etc: <EtcIcon /> };
export default function Sidebar({ isCollapsed, setIsCollapsed, width }: SidebarProps) {
  const { mode, user, coreUser } = useAuth();
  const visibleNavigation = navigation.map(group => ({
    ...group,
    items: group.items.filter(item =>
      (item.mode !== 'basic' || mode === 'basic') &&
      (!item.permission || hasCorePermission(mode, user, coreUser, item.permission))
    ),
  })).filter(group => group.items.length > 0);
  return <Shell $width={width}>
    <Brand $collapsed={isCollapsed}><LogoSvg size={28} />{!isCollapsed && <div><strong>콜리스 콘솔</strong><small>시스템</small></div>}</Brand>
    <Nav aria-label="업무 메뉴">{visibleNavigation.map(group => <Group key={group.label}>
      {!isCollapsed && <Label>{group.label}</Label>}
      {group.items.map(item => <Item key={item.path} to={item.path} $collapsed={isCollapsed} aria-label={item.label} title={isCollapsed ? item.label : undefined}>
        {icons[item.icon]}{!isCollapsed && <span>{item.label}</span>}
      </Item>)}
    </Group>)}</Nav>
    <Footer><Collapse onClick={() => setIsCollapsed(!isCollapsed)} aria-label={isCollapsed ? '메뉴 펼치기' : '메뉴 접기'} aria-expanded={!isCollapsed}>
      {isCollapsed ? <MenuUnfoldIcon /> : <><MenuFoldIcon />메뉴 접기</>}
    </Collapse></Footer>
  </Shell>;
}
